import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '../../components/button/button.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
import { ValidationService } from '../../services/validation.service';

@Component({
  selector: 'app-student-form-page',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, HeaderComponent, TextInputComponent, ButtonComponent, SelectInputComponent],
  templateUrl: './student-form-page.component.html',
  styleUrl: './student-form-page.component.css'
})
export class StudentFormPageComponent {
  form: FormGroup;
  selected_item: any = {};
  showPasswordField: boolean = true;
  isSubmitting = false;

  constructor(
    public gs: GlobalService,
    public ds: DropdownService,
    public vs: ValidationService,
    public fb: FormBuilder,
    public us: UserService,
    public route: Router,
    public ar: ActivatedRoute,
  ) {
    this.form = this.fb.group({
      role_id: [''],
      university_id: ['', [Validators.required]],
      academic_year_id: ['', [Validators.required]],
      registration_number: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/)]],
      first_name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.new_name_pattern)]],
      last_name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.new_name_pattern)]],
      contact: [null, [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact)]],
      email: ['', [Validators.required, Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      password: ['', [Validators.required, Validators.pattern(this.vs.password_complex_pattern)]],
      is_active: [true],
      user_type: ''
    });
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['role', 'university', 'exam', 'subject', 'college', 'academic-year']);
    this.ar.queryParams.subscribe(async params => {
      if (params['id']) {
        const res = await this.us.get(params['id']);
        this.selected_item = { ...res.data };
        const nameParts = (this.selected_item.name || '').split(' ');
        this.form.patchValue({
          ...this.selected_item,
          first_name: nameParts[0] || '',
          last_name: nameParts.slice(1).join(' ') || '',
        });
        this.showPasswordField = false;
        this.form.get('password')?.clearValidators();
        this.form.get('password')?.reset();
        this.form.get('password')?.updateValueAndValidity();
      }
    });
  }

  resetPassword() {
    this.showPasswordField = true;
    this.form.get('password')?.reset();
    this.form.get('password')?.setValidators([
      Validators.required,
      Validators.pattern(this.vs.password_complex_pattern)
    ]);
    this.form.get('password')?.updateValueAndValidity();
  }

  discard() {
    this.route.navigate(['/user/student-list']);
  }

  async submit() {
    if (this.isSubmitting) return;
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    try {
      let payload: any = {
        ...this.form.value,
        user_type: 'student',
        name: `${this.form.value.first_name} ${this.form.value.last_name}`.trim()
      };
      delete payload.first_name;
      delete payload.last_name;

      try {
        const studentRole = this.ds.dropdown_list?.role_list?.find((r: any) => (r.title || '').toString().toLowerCase().includes('student'));
        if (studentRole && studentRole.value) {
          payload.role_id = studentRole.value;
        }
      } catch (e) { }

      delete payload.image;
      payload.is_active = true;

      if (this.selected_item?.id) {
        if (!this.showPasswordField) {
          delete payload.password;
        }
        const res = await this.us.update(this.selected_item.id, payload);
        this.gs.toastr_shows_function(res.message, 'Success', 'success');
      } else {
        await this.us.add(payload);
        this.gs.toastr_shows_function('Student created successfully', 'Success', 'success');
      }
      this.route.navigate(['/user/student-list']);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
}
